<template>
      <div class="row pt70">
        <div class="col-lg-6 offset-lg-3 text-center">
          <div class="main-title hvr-float-shadow">
            <h2 class="text-uppercase">Corporate <span class="text-thm">Clients</span></h2>
          </div>
        </div>
      </div>
	 <!-- our swiper slider section state -->
	 <div class="my-5 swiper mySwiper" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div class="swiper-slide"
          v-for="(slide, index) in this.CorporateClients" :key="index">
          <img :src="this.adminurl + 'fontend/corporate/' + slide.image" :alt="slide.image" class="img-fluid" />
        </div>
      </div>
    </div>
    <!-- our swiperslider  section end -->

	<section id="mr-hide" class="ulockd-footer">
		<div class="adjustable-container container">
			<div class="row left-right g-5">
				<div class="col-sm-12 col-xl-4">
					<div class="ulockd-footer-widget">
						<img  alt="footer-logo.png" :src="this.adminurl + 'footer_logo.png'"
							class="mr-img-ftr pb-4">
						<p class="ulockd-ftr-text ">Prime Medical College & Hospital | Leading Healthcare & Education
							meta description: Discover Prime Medical College & Hospital in Rangpur, Bangladesh, offering
							top-tier medical education and comprehensive healthcare services.</p>
					</div>
				</div>
				<div class="col-sm-12 col-xl-4">
					<div class="ulockd-footer-lnews ps-4">
						<h3 class="text-uppercase fs-40">Dhaka Office</h3>
						<div class="ulockd-media-box">
							<div class="d-flex mb20">
								<div  class="h-30 flex-shrink-0 ms-0 me-3"> <img id="footerIconHide" class="w-100 img-thumbnail"
										src="images/footer/download (1).png" alt="s1.jpg"> </div>
								<div class="flex-grow-1 ms-3">
									<p>T.K Bhaban (9th Floor),
										13, Kawran Bazar,
										Dhaka, 1215</p>
								</div>
							</div>
							<div class="d-flex">
								<div  class="h-30 flex-shrink-0 ms-0 me-3"> <img class="w-100 img-thumbnail"
										src="images/footer/pmc-clock.png" alt="s2.jpg"> </div>
								<div class="flex-grow-1 ms-3"> <a href="#" class=" fs-40  post-date">Update</a>

									<p class="fs-40">22.01.2025 11:09 AM
										Updated by <a class=" fs-40  text-white" href="https://www.nsmlimited.com/">NSM limited</a> </p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xl-4">
					<div class="flickr-widget">
						<h3 class="fs-40 text-uppercase">Google Map Direction</h3>
						<ul>
							<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28751.400412239163!2d89.216821!3d25.739992!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e332235520e46d%3A0xbc9f00afb9ea67e3!2sPrime%20Medical%20College!5e0!3m2!1sen!2sus!4v1737523529737!5m2!1sen!2sus" height="200" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
						</ul>
					</div>
				</div>
        
			</div>
		</div>
	</section>
  <section id="mobileApointment" class="ulockd-footer">
		<div class="container-fluid">
			<div class="row left-right g-5">
				<div class="col-sm-12 col-xl-4">
					<div class="ulockd-footer-widget">
						<img  alt="footer-logo.png" :src="this.adminurl + 'footer_logo.png'"
							class="mr-img-ftr pb-4">
						<p class="ulockd-ftr-text ">Prime Medical College & Hospital | Leading Healthcare & Education
							meta description: Discover Prime Medical College & Hospital in Rangpur, Bangladesh, offering
							top-tier medical education and comprehensive healthcare services.</p>
					</div>
				</div>
				<div class="col-sm-12 col-xl-4">
					<div class="ulockd-footer-lnews ps-4">
						<h3 class="text-uppercase fs-40">Dhaka Office</h3>
						<div class="ulockd-media-box">
							<div class="d-flex mb20">
								<div  class="h-30 flex-shrink-0 ms-0 me-3"> <img id="footerIconHide" class="w-100 img-thumbnail"
										src="images/footer/download (1).png" alt="s1.jpg"> </div>
								<div class="flex-grow-1 ms-3">
									<p>T.K Bhaban (9th Floor),
										13, Kawran Bazar,
										Dhaka, 1215</p>
								</div>
							</div>
							<div class="d-flex">
								<div  class="h-30 flex-shrink-0 ms-0 me-3"> <img class="w-100 img-thumbnail"
										src="images/footer/pmc-clock.png" alt="s2.jpg"> </div>
								<div class="flex-grow-1 ms-3"> <a href="#" class=" fs-40  post-date">Update</a>

									<p class="fs-40">22.01.2025 11:09 AM
										Updated by <a class=" fs-40  text-white" href="https://www.nsmlimited.com/">NSM limited</a> </p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xl-4">
					<div class="flickr-widget">
						<h3 class="fs-40 text-uppercase">Google Map Direction</h3>
						<ul>
							<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28751.400412239163!2d89.216821!3d25.739992!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e332235520e46d%3A0xbc9f00afb9ea67e3!2sPrime%20Medical%20College!5e0!3m2!1sen!2sus!4v1737523529737!5m2!1sen!2sus" height="200" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
						</ul>
					</div>
				</div>
        
			</div>
		</div>
	</section>
</template>
<script>
import axios from 'axios';
import { onMounted, ref, computed } from "vue";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { useStore } from 'vuex';

export default {
	name: "SwiperSlider",
	computed: {
		adminurl() {
			return this.$store.state.adminurl;
		},
		url() {
			return this.$store.state.url;
		},
	},
 setup() {
    const swiperContainer = ref(null);
    const CorporateClients = ref([]);
    const store = useStore();
    const adminurl = computed(() => store.state.adminurl);

    const fetchSlides = async () => {
      try {
        const response = await axios.get(adminurl.value + 'api/corporateClient');
        if (response.data && Array.isArray(response.data)) {
          CorporateClients.value = response.data;
        }
      } catch (error) {
        console.error('Error fetching slides data:', error);
        // Optionally, you could add a user-friendly message here.
      }
    };

    onMounted(() => {
      // Initialize Swiper with autoplay
      if (swiperContainer.value) {
        const swiper = new Swiper(swiperContainer.value, {
          slidesPerView: 4,
          spaceBetween: 20,
          autoplay: {
            delay: 2000,  // Set autoplay delay
            disableOnInteraction: false,  // Continue autoplay even when the user interacts
          },
          loop: true,  // Keeps the carousel looping
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          grabCursor: true,
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
          },
        });
      }

      // Fetch Corporate Client slides
      fetchSlides();
    });
    return { swiperContainer, CorporateClients, adminurl };
  },
};
</script>
<style scoped>
p {
	color: #aaa;
}
.h-45 {
	height: 45px;
}
.h-30 {
  width: 30px ;
}
</style>